// Traduções deste componente — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'form.searchableSelect.loadError': 'Não foi possível carregar as opções.',
    'form.searchableSelect.noOptions': 'Nenhuma opção encontrada',
    'form.searchableSelect.searching': 'Buscando…',
    'form.searchableSelect.searchField': 'Buscar {{field}}…',
    'form.searchableSelect.optionFallback': 'opção',
    'form.searchableSelect.openOptions': 'Abrir opções',
    'form.searchableSelect.closeOptions': 'Fechar opções',
    'form.searchableSelect.moreSelected_one': 'Mais {{count}} selecionado',
    'form.searchableSelect.moreSelected_other': 'Mais {{count}} selecionados',
    'form.searchableSelect.selectOption': 'Selecionar opção',
    'form.searchableSelect.clearSearch': 'Limpar busca',
    'form.searchableSelect.clearSelection': 'Limpar seleção',
    'form.searchableSelect.optionsAvailable_one': '{{count}} opção disponível',
    'form.searchableSelect.optionsAvailable_other': '{{count}} opções disponíveis',
  },
  en: {
    'form.searchableSelect.loadError': 'Unable to load options.',
    'form.searchableSelect.noOptions': 'No options found',
    'form.searchableSelect.searching': 'Searching…',
    'form.searchableSelect.searchField': 'Search {{field}}…',
    'form.searchableSelect.optionFallback': 'option',
    'form.searchableSelect.openOptions': 'Open options',
    'form.searchableSelect.closeOptions': 'Close options',
    'form.searchableSelect.moreSelected_one': '{{count}} more selected',
    'form.searchableSelect.moreSelected_other': '{{count}} more selected',
    'form.searchableSelect.selectOption': 'Select an option',
    'form.searchableSelect.clearSearch': 'Clear search',
    'form.searchableSelect.clearSelection': 'Clear selection',
    'form.searchableSelect.optionsAvailable_one': '{{count}} option available',
    'form.searchableSelect.optionsAvailable_other': '{{count}} options available',
  },
  es: {
    'form.searchableSelect.loadError': 'No se pudieron cargar las opciones.',
    'form.searchableSelect.noOptions': 'No se encontraron opciones',
    'form.searchableSelect.searching': 'Buscando…',
    'form.searchableSelect.searchField': 'Buscar {{field}}…',
    'form.searchableSelect.optionFallback': 'opción',
    'form.searchableSelect.openOptions': 'Abrir opciones',
    'form.searchableSelect.closeOptions': 'Cerrar opciones',
    'form.searchableSelect.moreSelected_one': 'Otro {{count}} seleccionado',
    'form.searchableSelect.moreSelected_other': 'Otros {{count}} seleccionados',
    'form.searchableSelect.selectOption': 'Seleccionar una opción',
    'form.searchableSelect.clearSearch': 'Limpiar búsqueda',
    'form.searchableSelect.clearSelection': 'Limpiar selección',
    'form.searchableSelect.optionsAvailable_one': '{{count}} opción disponible',
    'form.searchableSelect.optionsAvailable_other': '{{count}} opciones disponibles',
  },
}
